import { Row, Col, Divider } from "antd";
import {
  DashboardOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./cartop.css";

import { FormattedMessage, useIntl } from "react-intl";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import Typography from "../Typography";
import { COLORS } from "../../constants/Colors";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { getQueueOnworkApi } from "../../controllers/home/CardHomeAPI";

const CardTopHome = (props) => {
  const { type, queueList, queueTotal, menu,setitemCate } = props;
  const isDesktop = useIsDesktop();

  const [data, setData] = useState({})

  useEffect(() => {
    const getQueueOnwork = async () => {
      const currentDate = moment().format('YYYY-MM-DD')
      // const currentDate = '2024-12-01'
      try { 
        const response = await getQueueOnworkApi(currentDate);
        setData(_.get(response, 'data'))
        setitemCate(_.get(response,'data.itemCategoryId'))
        console.log('currentDate', _.get(response,'data.itemCategoryId') , currentDate, response)
      } catch (error) {}
    }
    getQueueOnwork();
  }, [])

  console.log("CardTopHome", type, queueList);

  const parkingContent = (
    <div className="div-card-top">
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <Row style={{ marginTop: "0px" }}>
          <Col span={isDesktop ? 12 : 16}>
            <Typography
              className="pb-1 px-4"
              isBold
              color={COLORS.Primary}
              size={"18px"}
              style={{paddingTop: '35px'}}
            >
              <FormattedMessage
                id="HomeParkingTitle"
                defaultMessage="ช่องจอดทั้งหมด"
              />
            </Typography>
            {/* <Typography
              className="pt-1 pb-3 px-4"
              isBold
              color={COLORS.Dark}
              size={"12px"}
            >
              Lorem ipsum dolor sit amet
            </Typography> */}
          </Col>
          <Col className="right-card-top" span={isDesktop ? 12 : 8}>
            <Typography
              className="pt-4 pb-1 px-1"
              isBold
              color={COLORS.Primary}
              size={"48px"}
              textAlign={"right"}
            >
              {queueTotal}
            </Typography>
            <Typography
              className="pl-1 pr-4"
              isBold
              color={COLORS.Primary}
              size={"18px"}
              style={{ paddingTop: "35px", paddingBottom: "35px" }}
            >
              <FormattedMessage id="HomeParkingSpace" defaultMessage="ช่อง" />
            </Typography>
          </Col>
        </Row>
      </div>
    </div>
  );

  const queueContent = (
    <div className="div-card-top">
      <div className="d-flex flex-column justify-content-center text-left w-100">
        {isDesktop ? (
          <Row style={{ marginTop: "0px" }}>
            <Col span={menu === "queue" ? 12 : 12}>
              <Typography
                className="pb-1 px-4"
                isBold
                color={COLORS.Primary}
                size={"18px"}
                style={{paddingTop: _.get(data, "queueNo") ? '35px' : '25px'}}
              >
                <FormattedMessage
                  id="QueueRunningTitle"
                  defaultMessage="คิวที่กำลังทำอยู่"
                />
              </Typography>
              {/* <Typography
                className="pt-1 pb-3 px-4"
                isBold
                color={COLORS.Dark}
                size={"12px"}
              >
                {menu === "queue"
                  ? "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed"
                  : "Lorem ipsum dolor sit amet"}
              </Typography> */}
            </Col>
            <Col className="right-card-top" span={menu === "queue" ? 12 : 12}>
              <Typography
                className="px-3"
                isBold
                color={COLORS.Primary}
                size={"48px"}
                textAlign={"right"}
                style={{ paddingTop: "30px", paddingBottom: "40px" }}
              >
                {_.get(data, "queueNo")}
              </Typography>
            </Col>
            {/* <Col span={menu === "queue" ? 3 : 6}>
              <Typography
                className="pt-3 pb-1 px-1"
                isBold
                color={COLORS.Primary}
                size={"18px"}
              >
                <FormattedMessage
                  id="ServiceTitle"
                  defaultMessage="เวลาบริการ"
                />
              </Typography>
              <Typography
                className="pt-1 pb-3 pl-1 pt-1"
                color={COLORS.Dark}
                size={"16px"}
              >
                {_.get(data, "deliveryDate")
                  ? moment(_.get(data, "deliveryDate")).format("DD/MM/YYYY") +
                    " " +
                     // _.get(data, "deliveryTime")
                     moment().format("HH:mm")
                  : ""}
              </Typography>
            </Col> */}
          </Row>
        ) : (
          <div>
            <Row style={{ marginTop: "15px" }}>
              <Col span={16}>
                <Typography
                  className="pb-1 px-4"
                  isBold
                  color={COLORS.Primary}
                  size={"18px"}
                  style={{  paddingTop: _.get(data, "queueNo") ? '30px' : "20px" }}
                >
                  <FormattedMessage
                    id="QueueRunningTitle"
                    defaultMessage="คิวที่กำลังทำอยู่"
                  />
                </Typography>
                {/* <Typography
                  className="pt-1 pb-3 px-4"
                  isBold
                  color={COLORS.Dark}
                  size={"12px"}
                >
                  {menu === "queue"
                    ? "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed"
                    : "Lorem ipsum dolor sit amet"}
                </Typography> */}
              </Col>
              <Col className="right-card-top" span={8}>
                <Typography
                  className="px-3"
                  isBold
                  color={COLORS.Primary}
                  size={"48px"}
                  textAlign={"right"}
                  style={{ paddingTop: "30px", paddingBottom: "40px" }}
                >
                  {_.get(data, "queueNo")}
                </Typography>
              </Col>
            </Row>
            {/* <Row>
              <Col span={12}>
                <Typography
                  className="pt-1 pb-1 px-4"
                  isBold
                  color={COLORS.Primary}
                  size={"18px"}
                >
                  <FormattedMessage
                    id="ServiceTitle"
                    defaultMessage="เวลาบริการ"
                  />
                </Typography>
              </Col>
              <Col className="right-card-top" span={12}>
                <Typography
                  className="pt-1 px-3 mb-4"
                  color={COLORS.Dark}
                  size={"16px"}
                >
                  {_.get(data, "deliveryDate")
                    ? moment(_.get(data, "deliveryDate")).format("DD/MM/YYYY") +
                      " " +
                      // _.get(data, "deliveryTime")
                      moment().format("HH:mm")
                    : ""}
                </Typography>
              </Col>
            </Row> */}
          </div>
        )}
      </div>
    </div>
  );

  return type === "queue" ? queueContent : parkingContent;

};

export default CardTopHome;
